import api from './client'

/** Fichas técnicas propuestas para un producto (con su fuente): aprobar o rechazar. */
export const fichasCandidatasApi = {
  listar: () => api.get('/fichas-candidatas'),
  buscar: (sku) => api.post('/fichas-candidatas/buscar', { sku }),
  aprobar: (id) => api.post(`/fichas-candidatas/${id}/aprobar`),
  rechazar: (id, motivo) => api.post(`/fichas-candidatas/${id}/rechazar`, { motivo }),
}
